import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const html = document.querySelector('html') as HTMLHtmlElement;
    html.style.scrollBehavior = 'auto';

    document.documentElement.scrollTo(0, 0);

    html.style.scrollBehavior = 'smooth';
  }, [pathname]);
};
